/**
 * Query params for /payments — include relations for invoice, type, gateway labels.
 */
/**
 * Eager-load nested invoice lead + type/gateway (API returns snake_case on the payload).
 * Brand and account hang off the invoice, not off the payment — asking for a bare
 * `brand` makes the API throw RelationNotFoundException on App\Models\Payment.
 */
export const PAYMENT_RELATIONS = [
  'paymentType',
  'invoice.order.lead',
  'invoice.brand',
  'invoice.account',
  'paymentGateway',
];

export const buildPaymentRelationParams = () =>
  PAYMENT_RELATIONS.reduce((acc, rel, i) => {
    acc[`relations[${i}]`] = rel;
    return acc;
  }, {});

/** Build FormData for PUT /payments/:id/status (with _method=PUT). */
export const buildPaymentStatusFormData = ({
  status,
  transaction_id,
  transaction_time,
  note,
}) => {
  const fd = new FormData();
  fd.append('_method', 'PUT');
  fd.append('status', status);
  fd.append('transaction_id', transaction_id ?? '');
  fd.append('transaction_time', transaction_time);
  if (note) fd.append('note', note);
  return fd;
};
